import { render, staticRenderFns } from "./SendBulk.vue?vue&type=template&id=27c085a8&scoped=true&"
import script from "./SendBulk.vue?vue&type=script&lang=js&"
export * from "./SendBulk.vue?vue&type=script&lang=js&"
import style0 from "./SendBulk.vue?vue&type=style&index=0&id=27c085a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c085a8",
  null
  
)

component.options.__file = "SendBulk.vue"
export default component.exports